import React, { useCallback, useState } from 'react';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { useMultiFactorAuthenticationContext } from './MultiFactorAuthenticationContext';
import { MultiFactorAuthenticationType } from '../../../Infrastructure/API/MultiFactorAuthentication/list';
import Email from './Email';
import Sms from './Sms';
import Totp from './Totp';
import { FormRenderProps } from 'react-final-form';
import AlternativeMethods from './AlternativeMethods';
import { useCountdownTimer } from './useCountdownTimer';

interface MultiFactorAuthenticationLoginProps {
  formRenderProps: FormRenderProps;
  onGoBackToLoginClick: () => void;
  isRedirecting: boolean;
}

const MultiFactorAuthenticationLogin = ({
  formRenderProps,
  onGoBackToLoginClick,
  isRedirecting,
}: MultiFactorAuthenticationLoginProps) => {
  const { defaultAuthentication } = useMultiFactorAuthenticationContext();
  const emailCountdownTimer = useCountdownTimer();
  const smsCountdownTimer = useCountdownTimer();

  const [activeAuthentication, setActiveAuthentication] = useState<MultiFactorAuthenticationType | null>();

  const handleChooseAnotherMethodClick = useCallback(() => {
    setActiveAuthentication(null);
  }, []);

  const isActive = (authenticationType: MultiFactorAuthenticationType) => {
    if (isUndefined(activeAuthentication)) {
      return defaultAuthentication?.provider === authenticationType;
    }
    return activeAuthentication === authenticationType;
  };

  const isListActive =
    isNull(activeAuthentication) || (isUndefined(activeAuthentication) && isUndefined(defaultAuthentication));

  return (
    <>
      {isActive(MultiFactorAuthenticationType.TOTP) && (
        <Totp
          formRenderProps={formRenderProps}
          onGoBackToLoginClick={onGoBackToLoginClick}
          onChooseAnotherMethodClick={handleChooseAnotherMethodClick}
          isRedirecting={isRedirecting}
        />
      )}
      {isActive(MultiFactorAuthenticationType.SMS) && (
        <Sms
          formRenderProps={formRenderProps}
          countdownTimer={smsCountdownTimer}
          onGoBackToLoginClick={onGoBackToLoginClick}
          onChooseAnotherMethodClick={handleChooseAnotherMethodClick}
          isRedirecting={isRedirecting}
        />
      )}
      {isActive(MultiFactorAuthenticationType.Email) && (
        <Email
          formRenderProps={formRenderProps}
          countdownTimer={emailCountdownTimer}
          onGoBackToLoginClick={onGoBackToLoginClick}
          onChooseAnotherMethodClick={handleChooseAnotherMethodClick}
          isRedirecting={isRedirecting}
        />
      )}
      {isListActive && (
        <AlternativeMethods onGoBackToLoginClick={onGoBackToLoginClick} onSubmit={setActiveAuthentication} />
      )}
    </>
  );
};

export default MultiFactorAuthenticationLogin;
